import { PlannerMultiple } from 'mixs/orders/planner';

class MyschedulesIndex extends PlannerMultiple {
}

riot.mixin('myschedules.index', MyschedulesIndex as riot.TagMixin)
